var map = {
	"./icon-celular-gray-with-shield.svg": "65f5",
	"./icon-notebook-gray-with-shield.svg": "5ed0",
	"./icon-smartwatch-gray-with-shield.svg": "8132",
	"./icon-tablet-gray-with-shield.svg": "9e67"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b19c";